import { render, staticRenderFns } from "./AdminNpsPage.vue?vue&type=template&id=89c06d84&scoped=true"
import script from "./AdminNpsPage.vue?vue&type=script&lang=js"
export * from "./AdminNpsPage.vue?vue&type=script&lang=js"
import style0 from "./AdminNpsPage.vue?vue&type=style&index=0&id=89c06d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c06d84",
  null
  
)

export default component.exports